import React from "react";
import styled from "styled-components";

const ModelPreview = ({ url, name }) => {
  return (
    <Container class="sketchfab-embed-wrapper">
      <ModelIframe
        title={`${name}`}
        frameborder="0"
        allowfullscreen
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        xr-spatial-tracking
        execution-while-out-of-viewport
        execution-while-not-rendered
        web-share
        width="870"
        height="494"
        src={`${url}`}
      ></ModelIframe>
    </Container>
  );
};

export default ModelPreview;

const Container = styled.div`
  @media only screen and (max-width: 1200px) {
    margin: 0 auto;
  }
`;

const ModelIframe = styled.iframe`
  border-radius: 8px;
  @media only screen and (max-width: 1200px) {
    width: 98vw;
    height: 60vh;
  }
`;
